//Constants for the Analytics Usecases
export const AnalyticsConstants = {
  taskArtifacts: 'taskArtifacts',
  PAXTaskArtifacts: 'PAXTaskArtifacts',
  discoverReimaginedSearch: 'Discover Reimagined Search',
  NoIssues: 'NoIssues',
  ZeroResults: 'ZeroResults',
  falseString: 'false',
  trueString: 'true',
  UsageMode: 'Browser',
  date: 'date',
  contentAge: 'ContentAge',
  compact: 'Compact',
  Query: 'Query: ',
  OpenResultItem: 'OpenResultItem:',
  NoRefinersApplied: 'No refiners applied'
};
export const ItemClickTypeAnalytics = {
  View: 'View',
  Preview: 'Preview',
  Access: 'Access',
  Default:''
};
